// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__bMDNk","footerItem":"Footer_footerItem__yaFNE"};